export const isMockEnabled = () => {
  if (typeof window !== 'undefined' && window.location) {
    const hostname = window.location.hostname;
    const isDevOrStaging = hostname.includes('dev-') || hostname.includes('staging-');

    if (isDevOrStaging) {
      const params = new URLSearchParams(window.location.search);
      return params.get('mock') === 'true';
    }

    if (hostname.includes('localhost') || hostname.includes('127.0.0.1')) {
      return true;
    }

    const params = new URLSearchParams(window.location.search);
    if (params.get('mock') === 'true' || params.has('override') || params.has('scenario')) {
      return true;
    }
  }

  if (process.env.NODE_ENV === 'development') return true;
  if (process.env.REACT_APP_ENABLE_MSW === 'true') return true;

  return false;
};
